export default __webpack_public_path__ + "static/footer_logo-06daecad4bd3f7536ba925094106e8a1.svg";